module.exports = require('./helpers/bundle-url').getBundleURL('4Im5F') + "logo-dark.eefe0b7f.svg";